<kendo-uploaddropzone
  class="dropzone"
  [class.disabled]="disabled()"
  [class.drag-over]="dragOver()"
  [zoneId]="zoneId"
  (dragover)="dragOver.set(true)"
  (dragleave)="onDragLeave($event)"
  (drop)="dragOver.set(false)">
  <span class="prompt">
    Drag and drop {{ itemLabel() }} here or
    <button
      type="button"
      class="browse"
      [disabled]="disabled()"
      (click)="browse(fileSelect)">
      browse
    </button>
  </span>
  <span class="hint">{{ hint() }}</span>
</kendo-uploaddropzone>

<kendo-fileselect
  #fileSelect
  class="d-none"
  [zoneId]="zoneId"
  [multiple]="true"
  [disabled]="disabled()"
  [restrictions]="restrictions()"
  [showFileList]="false"
  (select)="onSelect($event)" />

@if (errors().length > 0) {
  <ul class="errors" role="alert">
    @for (error of errors(); track error) {
      <li>{{ error }}</li>
    }
  </ul>
}

@if (entries().length > 0) {
  <div class="files-header">
    <span>{{ entries().length }} of {{ maxFiles() }} files</span>
  </div>
  <ul class="files">
    @for (entry of entries(); track entry.file) {
      <li class="file">
        @if (entry.previewUrl) {
          <img class="thumb" alt="" [src]="entry.previewUrl" />
        } @else {
          <span class="thumb">
            <kendo-icon name="file" />
          </span>
        }
        <span class="name" [title]="entry.file.name">
          {{ entry.file.name }}
        </span>
        <span class="size">{{ entry.size }}</span>
        <button
          kendoButton
          type="button"
          fillMode="flat"
          size="small"
          class="remove"
          icon="x"
          [disabled]="disabled()"
          [attr.aria-label]="'Remove ' + entry.file.name"
          (click)="remove(entry.file)"></button>
      </li>
    }
  </ul>
}
